module.exports = __webpack_public_path__ + "static/media/Template Details.4935a82a.png";